module.exports = __webpack_public_path__ + "assets/img/icon-newmember.7454d343.svg";